export default {
  sm: `
  Energy efficiency 
  in harmony with nature
  `,
  lg: `
  Energy efficiency 
  in harmony with 
  nature
  `,
  xxl: `
  Energy efficiency 
  in harmony 
  with nature
  `
};
